import { background } from 'assets/backgrounds'
import SocialMediaLinks from 'cwp-components/SocialMediaLinks/SocialMediaLinks'

interface BannerProps {
  title: string
  imgSrc: string
}
const Banner = ({ title, imgSrc }: BannerProps) => {
  return (
    <div
      className='relative template-area w-full md:bg-cover md:bg-center md:mt-[-20px]  md:min-h-[466px] h-auto'
      style={{ backgroundImage: `url(${background.legalSubField.banner})` }}
    >
      <div className='px-2.5 sm:px-4 md:p-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <div className='py-5'>
          <div className='flex flex-col md:flex-row-reverse items-center gap-4'>
            {imgSrc && (
              <div className='w-full md:w-7/12 '>
                <img
                  src={imgSrc}
                  alt={`Image illustrating ${title}`}
                  className='h-[200px] object-cover flex bg-[#101828] w-full max-w-[480px] ml-auto'
                />
              </div>
            )}
            <div className='w-full md:w-5/12'>
              <div className='h-100 w-full max-w-[762px]'>
                <h3 className='text-lg sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl 2xl:text-[64px] font-bold text-[#122D5C] leading-none pt-4 md:pt-0 '>
                  {title}
                </h3>
                <p className='text-xs sm:text-sm md:text-base lg:text-lg font-bold text-[#001A3D] leading-[24px] tracking-wide  my-2 md:my-3'>
                  All things related to "{title}”.
                </p>
                <SocialMediaLinks />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Banner
